/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum LanguageCode {
  Danish = "da",
  English = "en",
  Finnish = "fi",
  Swedish = "sv",
}

export enum CountryCode {
  Danish = "DK",
  Finnish = "FI",
}

export const DEFAULT_LANGUAGE_CODE = LanguageCode.Danish;
export const DEFAULT_COUNTRY_CODE = CountryCode.Danish;
export const DEFAULT_COUNTRY_CODE_LOWERCASE =
  DEFAULT_COUNTRY_CODE.toLowerCase() as Lowercase<typeof DEFAULT_COUNTRY_CODE>;

export const COUNTRY_LIST: `${CountryCode}`[] = Object.values(CountryCode);

export const VALID_COUNTRY = COUNTRY_LIST.map(
  (country) => country.toLowerCase() as Lowercase<CountryCode>
);

export const VALID_LANGUAGE = {
  [CountryCode.Danish.toLowerCase()]: [
    LanguageCode.Danish,
    LanguageCode.English,
  ],
  [CountryCode.Finnish.toLowerCase()]: [
    LanguageCode.Finnish,
    LanguageCode.English,
    LanguageCode.Swedish,
  ],
} as Record<Lowercase<CountryCode>, LanguageCode[]>;
